import CountBadge from '@/components/elements/CountBadge/CountBadge';
import Icon from '@/components/icons/Icon';
import { classnames } from '@/helpers';
import { customTwMerge } from '@/helpers/theme';
import { HTMLAttributes } from 'react';

type DropdownProps = HTMLAttributes<HTMLButtonElement> & {
  toggleOpen: () => void;
  close?: () => void;
  isActive: boolean;
  isToggleOpen?: boolean;
  activeBadge?: number;
  variant?: 'primary' | 'secondary' | 'tertiary';
  large?: boolean;
  block?: boolean;
  label?: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
};

export const DropdownButton = ({
  className = '',
  children = null,
  icon = null,
  isActive = false,
  toggleOpen = null,
  close = null,
  isToggleOpen = false,
  activeBadge = 0,
  ...props
}: DropdownProps) => {
  return (
    <button
      className={customTwMerge(
        classnames(
          'text-m border-border_regular px-xs relative flex h-[32px] items-center justify-center rounded-lg border outline-none',
          className,
        ),
      )}
      {...props}>
      <div onClick={toggleOpen} className="absolute inset-0"></div>
      {icon && (
        <span className={classnames('flex flex-shrink-0 items-center justify-center', children && 'mr-xxs')}>
          {icon}
        </span>
      )}
      {children}
      {toggleOpen && (close || Boolean(activeBadge)) && (
        <>
          {isActive && close ? (
            <Icon variant="close" onClick={close} size="xs" />
          ) : (
            isActive &&
            Boolean(activeBadge > 0) && (
              <span className="pl-xs">
                <CountBadge count={activeBadge} handleClick={toggleOpen} />
              </span>
            )
          )}
        </>
      )}
      {!isActive && <Icon variant="chevron-s-down" size="xs" onClick={toggleOpen} />}
    </button>
  );
};
